<template>
  <div>
    <div v-if="$store.state.appLoading" class="app-loader" data-nosnippet>
      <AppLogo height="22px" class="q-mb-lg" />
      <q-spinner size="3rem" color="secondary" />
    </div>

    <q-layout view="lHr LpR lFr" class="view__container">
      <TheTitlebar data-nosnippet />

      <TheMenuSidebar />

      <TheChatSidebar @close="$store.commit('chat/SET_SIDEBAR', false)" />

      <q-page-container id="page_container">
        <q-page id="page" class="bg-background">
          <transition appear name="fade-slow" mode="out-in">
            <router-view :key="$route.path" class="router-view" />
          </transition>

          <TheFooter v-if="$route.name !== 'search'" />
        </q-page>
      </q-page-container>

      <q-page-sticky
          v-show="!showRightSidebar"
          position="bottom-right"
          :offset="[24, 0]"
          style="z-index: 1000; top: calc(100dvh - 108px);"
      >
        <div class="flex items-center justify-center q-gutter-x-md">
          <q-btn
              round
              icon="sym_r_auto_awesome"
              color="secondary"
              style="box-shadow: 0 1px 12px rgba(1, 1, 1, 0.2), 0 3px 6px rgba(1, 1, 1, 0.9), 0 3px 3px -4px rgba(1, 1, 1, 0.12) !important"
              size="19px"
              @click="$store.commit('chat/TOGGLE_SIDEBAR')"
          >
            <q-tooltip
                v-if="windowWidth > 769"
                anchor="center left"
                self="center right"
                max-width="300px"
                :offset="[6, 6]"
                persistent
            >
              Ask CarScience
            </q-tooltip>
          </q-btn>
        </div>
      </q-page-sticky>
    </q-layout>
  </div>
</template>

<script>
import TheFooter from "@/components/TheFooter";
import axios from "axios";
import TheMenuSidebar from "@/components/TheMenuSidebar.vue";
import TheTitlebar from "@/components/TheTitlebar.vue";
import TheChatSidebar from "@/components/TheChatSidebar.vue";
import ListingDialog from "@/components/ListingDialog.vue";
import { Dialog } from "quasar";
import AppLogo from "@/components/AppLogo.vue";

export default {
  components: {
    AppLogo,
    TheChatSidebar,
    TheTitlebar,
    TheMenuSidebar,
    TheFooter
  },
  data() {
    return {
      hideFloatingActionButton: false
    };
  },
  computed: {
    showRightSidebar() {
      return this.$store.state.chat.sidebarOpen;
    }
  },
  watch: {},
  created() {
    axios.defaults.headers.common["Authorization"] =
      "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImtpZCI6Im5ldHdvcmstcHVibGlzaGVyLXRva2VuIn0.eyJpc3MiOiJodHRwczpcL1wvYXBpLmp1bXBmZWVkLmNvbSIsImlhdCI6MTcwNzkyNTQ5MiwiZXhwIjozMjg1ODQ4NjkyLCJzY29wZSI6WyJjcmVhdGUiLCJyZWFkIiwidXBkYXRlIiwiZGVsZXRlIiwibGlzdCIsImFsbCJdLCJpcCI6IjE5Mi4xNjguNjUuMSIsInB1Ymxpc2hlcl9hY2NvdW50Ijoie1wiaWRcIjpcIjEwMDAxXCIsXCJidXNpbmVzc19pZFwiOlwiMTVcIixcIm5hbWVcIjpcIkp1bXBmZWVkIFB1Ymxpc2hlclwiLFwicGF5b3V0X3ZhbHVlX3JldGFpbl9wZXJjZW50YWdlXCI6XCIxMDBcIixcInRpbWVfY3JlYXRlZFwiOlwiMjAyMy0wMS0wNiAxODozMDowMVwiLFwidGltZV91cGRhdGVkXCI6bnVsbCxcImRlbGV0ZWRcIjpcIjBcIixcInRpbWVfZGVsZXRlZFwiOm51bGwsXCJkb21haW5cIjpcImNhcnNjaWVuY2UuY29tXCIsXCJwdWJsaXNoZXJfYWNjb3VudF9kb21haW5faWRcIjpcIjdcIn0ifQ.btUtWpqcArLi0bmQt5FnW4GFZYjAkbQqr9ozjtpMG-0";

    setTimeout(() => {
      this.checkInitialListingToDisplay();
    }, 500);
  },
  methods: {
    checkInitialListingToDisplay() {
      if (this.urlParams().get("pid")) {
        let productId = this.urlParams().get("pid");
        this.urlParams().delete("pid");
        window.history.replaceState(
          history.state,
          null,
          "?" + this.urlParams().toString()
        );
        Dialog.create({
          component: ListingDialog,
          componentProps: {
            productId: productId
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  background: color(background);

  .view__container {
    background: color(background);
    // height: calc(100vh - 24px);
    // width: calc(100vw - 24px);
    // border-radius: 12px;
    // margin: 12px auto;

    // box-shadow: $shadow-bottom;

    @include screen-sm {
      width: 100dvw;
      margin: 0;
      border-radius: 0;
    }
  }

  .app-loader {
    min-height: $full-screen-height;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000000;
    background: color(background);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
